import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { HoteldateTransformReturn } from 'lumen/transforms/hoteldate';

export const HIGHLIGHT_TYPE = {
  REVENUE_PRICE_PUSH: 'REVENUE_PRICE_PUSH',
  RESERVATION_PRICE_PUSH: 'RESERVATION_PRICE_PUSH',
  REVENUE_GENERAL: 'REVENUE_GENERAL',
  RESERVATION_GENERAL: 'RESERVATION_GENERAL',
  AUTOPILOT_ANNIVERSARY: 'AUTOPILOT_ANNIVERSARY',
  MARKET_LEADER: 'MARKET_LEADER',
  RESERVATION_MILESTONE: 'RESERVATION_MILESTONE',
  PRODUCT_LIFETIME: 'PRODUCT_LIFETIME',
} as const;

export type HighlightType =
  (typeof HIGHLIGHT_TYPE)[keyof typeof HIGHLIGHT_TYPE];

export const HIGHLIGHT_PERIOD_TYPE = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
} as const;

export type HighlightPeriodType =
  (typeof HIGHLIGHT_PERIOD_TYPE)[keyof typeof HIGHLIGHT_PERIOD_TYPE];

export interface RevenuePricePushData {
  pms_currency: string;
  price_change: number;
  revenue: number;
}

export interface ReservationPricePushData {
  pickup: number;
  price_change: number;
}

export interface RevenueGeneralData {
  pms_currency: string;
  revenue: number;
}

export interface ReservationGeneralData {
  pickup: number;
}

export interface AutopilotAnniversaryData {
  months?: number;
  pickup: number;
  price_pushes: number;
}

export interface MarketLeaderData {
  is_first_time: boolean;
}

export interface ReservationMilestoneData {
  pickup: number;
}

export interface ProductLifetimeData {
  months: number;
  pickup?: number;
}

export type HighlightData =
  | AutopilotAnniversaryData
  | MarketLeaderData
  | ProductLifetimeData
  | ReservationGeneralData
  | ReservationMilestoneData
  | ReservationPricePushData
  | RevenuePricePushData
  | RevenueGeneralData;

export default class Highlight extends Model {
  [Type] = 'roi-trophies/highlight' as const;

  @attr() declare highlightData: HighlightData;
  @attr('string') declare highlightType: HighlightType;
  @attr('hoteldate') declare periodEnd: HoteldateTransformReturn;
  @attr('hoteldate') declare periodStart: HoteldateTransformReturn;
  @attr('string') declare periodType: HighlightPeriodType | null;
}
